export const SET_APIKEY = 'SET_APIKEY';
export const LOG_OUT = 'LOG_OUT';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const CLEAR_EXPIRED_PASSWORD = 'CLEAR_EXPIRED_PASSWORD';
